module.exports = flarum.core.compat['tags/helpers/tagsLabel'];